import { ReviseComponent } from './components/revise/revise.component';
import { ReviseOptionComponent } from './components/revise/revise-option/revise-option.component';
import { ReviseService } from './services/revise.service';
import { WorkflowService } from './services/workflow.service';
import { WorkflowConfigService } from './services/workflow-config.service';
import {ResourceRestService} from './services/resource-rest.service';
import {BackComponent} from "@ispm/workflow/components/back/back.component";

export const WORKFLOW_COMPONENTS = [
  ReviseComponent,
  ReviseOptionComponent,
  BackComponent
];

export const WORKFLOW_SERVICES = [WorkflowConfigService, ReviseService, WorkflowService, ResourceRestService];
